'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.daysUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/daysUntil.js
// module id = 488
// module chunks = 0